import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
export interface TimezoneOption {
  value: string;
  label: string;
  offset: string;
}
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  deviceId: any;
  private timezones: TimezoneOption[] = [
    // UTC and GMT
    { value: 'UTC', label: 'UTC (Coordinated Universal Time)', offset: '+00:00' },
    { value: 'GMT', label: 'GMT (Greenwich Mean Time)', offset: '+00:00' },

    // North America
    { value: 'America/New_York', label: 'Eastern Time (New York)', offset: '-05:00/-04:00' },
    { value: 'America/Chicago', label: 'Central Time (Chicago)', offset: '-06:00/-05:00' },
    { value: 'America/Denver', label: 'Mountain Time (Denver)', offset: '-07:00/-06:00' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (Los Angeles)', offset: '-08:00/-07:00' },
    { value: 'America/Anchorage', label: 'Alaska Time (Anchorage)', offset: '-09:00/-08:00' },
    { value: 'Pacific/Honolulu', label: 'Hawaii Time (Honolulu)', offset: '-10:00' },
    { value: 'America/Phoenix', label: 'Arizona Time (Phoenix)', offset: '-07:00' },
    { value: 'America/Toronto', label: 'Eastern Time (Toronto)', offset: '-05:00/-04:00' },
    { value: 'America/Vancouver', label: 'Pacific Time (Vancouver)', offset: '-08:00/-07:00' },

    // Europe
    { value: 'Europe/London', label: 'London (GMT/BST)', offset: '+00:00/+01:00' },
    { value: 'Europe/Paris', label: 'Paris (CET/CEST)', offset: '+01:00/+02:00' },
    { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)', offset: '+01:00/+02:00' },
    { value: 'Europe/Rome', label: 'Rome (CET/CEST)', offset: '+01:00/+02:00' },
    { value: 'Europe/Madrid', label: 'Madrid (CET/CEST)', offset: '+01:00/+02:00' },
    { value: 'Europe/Amsterdam', label: 'Amsterdam (CET/CEST)', offset: '+01:00/+02:00' },
    { value: 'Europe/Brussels', label: 'Brussels (CET/CEST)', offset: '+01:00/+02:00' },
    { value: 'Europe/Vienna', label: 'Vienna (CET/CEST)', offset: '+01:00/+02:00' },
    { value: 'Europe/Zurich', label: 'Zurich (CET/CEST)', offset: '+01:00/+02:00' },
    { value: 'Europe/Stockholm', label: 'Stockholm (CET/CEST)', offset: '+01:00/+02:00' },
    { value: 'Europe/Moscow', label: 'Moscow (MSK)', offset: '+03:00' },
    { value: 'Europe/Istanbul', label: 'Istanbul (TRT)', offset: '+03:00' },

    // Asia
    { value: 'Asia/Dubai', label: 'Dubai (GST)', offset: '+04:00' },
    { value: 'Asia/Calcutta', label: 'India (IST)', offset: '+05:30' },
    { value: 'Asia/Dhaka', label: 'Bangladesh (BST)', offset: '+06:00' },
    { value: 'Asia/Bangkok', label: 'Bangkok (ICT)', offset: '+07:00' },
    { value: 'Asia/Singapore', label: 'Singapore (SGT)', offset: '+08:00' },
    { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT)', offset: '+08:00' },
    { value: 'Asia/Shanghai', label: 'China (CST)', offset: '+08:00' },
    { value: 'Asia/Tokyo', label: 'Japan (JST)', offset: '+09:00' },
    { value: 'Asia/Seoul', label: 'South Korea (KST)', offset: '+09:00' },
    { value: 'Asia/Jakarta', label: 'Jakarta (WIB)', offset: '+07:00' },
    { value: 'Asia/Manila', label: 'Philippines (PHT)', offset: '+08:00' },
    { value: 'Asia/Kuala_Lumpur', label: 'Malaysia (MYT)', offset: '+08:00' },
    { value: 'Asia/Karachi', label: 'Pakistan (PKT)', offset: '+05:00' },
    { value: 'Asia/Tehran', label: 'Iran (IRST)', offset: '+03:30/+04:30' },
    { value: 'Asia/Riyadh', label: 'Saudi Arabia (AST)', offset: '+03:00' },

    // Australia & Pacific
    { value: 'Australia/Sydney', label: 'Sydney (AEST/AEDT)', offset: '+10:00/+11:00' },
    { value: 'Australia/Melbourne', label: 'Melbourne (AEST/AEDT)', offset: '+10:00/+11:00' },
    { value: 'Australia/Brisbane', label: 'Brisbane (AEST)', offset: '+10:00' },
    { value: 'Australia/Perth', label: 'Perth (AWST)', offset: '+08:00' },
    { value: 'Australia/Adelaide', label: 'Adelaide (ACST/ACDT)', offset: '+09:30/+10:30' },
    { value: 'Pacific/Auckland', label: 'New Zealand (NZST/NZDT)', offset: '+12:00/+13:00' },
    { value: 'Pacific/Fiji', label: 'Fiji (FJT)', offset: '+12:00/+13:00' },

    // Africa
    { value: 'Africa/Cairo', label: 'Cairo (EET)', offset: '+02:00' },
    { value: 'Africa/Johannesburg', label: 'South Africa (SAST)', offset: '+02:00' },
    { value: 'Africa/Lagos', label: 'Lagos (WAT)', offset: '+01:00' },
    { value: 'Africa/Nairobi', label: 'Nairobi (EAT)', offset: '+03:00' },
    { value: 'Africa/Casablanca', label: 'Casablanca (WET)', offset: '+00:00/+01:00' },

    // South America
    { value: 'America/Sao_Paulo', label: 'Brazil (BRT/BRST)', offset: '-03:00/-02:00' },
    { value: 'America/Argentina/Buenos_Aires', label: 'Argentina (ART)', offset: '-03:00' },
    { value: 'America/Lima', label: 'Peru (PET)', offset: '-05:00' },
    { value: 'America/Bogota', label: 'Colombia (COT)', offset: '-05:00' },
    { value: 'America/Caracas', label: 'Venezuela (VET)', offset: '-04:00' },
    { value: 'America/Santiago', label: 'Chile (CLT/CLST)', offset: '-04:00/-03:00' },
  ];

  getTimezones(): TimezoneOption[] {
    return this.timezones;
  }

  getDefaultTimezone(): string {
    // Try to detect user's timezone
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      return 'UTC';
    }
  }

  getTimezoneLabel(timezone: string): string {
    const found = this.timezones.find(tz => tz.value === timezone);
    return found ? found.label : timezone;
  }

  getTimezoneOffset(timezone: string): string {
    const found = this.timezones.find(tz => tz.value === timezone);
    return found ? found.offset : '+00:00';
  }

  // Group timezones by region for better UI
  getGroupedTimezones(): { [key: string]: TimezoneOption[] } {
    const grouped: { [key: string]: TimezoneOption[] } = {
      'UTC/GMT': [],
      'North America': [],
      Europe: [],
      Asia: [],
      'Australia & Pacific': [],
      Africa: [],
      'South America': [],
    };

    this.timezones.forEach(timezone => {
      if (timezone.value === 'UTC' || timezone.value === 'GMT') {
        grouped['UTC/GMT'].push(timezone);
      } else if (
        timezone.value.startsWith('America/') ||
        timezone.value.startsWith('Pacific/Honolulu')
      ) {
        if (
          timezone.value.includes('Sao_Paulo') ||
          timezone.value.includes('Argentina') ||
          timezone.value.includes('Lima') ||
          timezone.value.includes('Bogota') ||
          timezone.value.includes('Caracas') ||
          timezone.value.includes('Santiago')
        ) {
          grouped['South America'].push(timezone);
        } else {
          grouped['North America'].push(timezone);
        }
      } else if (timezone.value.startsWith('Europe/')) {
        grouped['Europe'].push(timezone);
      } else if (timezone.value.startsWith('Asia/')) {
        grouped['Asia'].push(timezone);
      } else if (timezone.value.startsWith('Australia/') || timezone.value.startsWith('Pacific/')) {
        grouped['Australia & Pacific'].push(timezone);
      } else if (timezone.value.startsWith('Africa/')) {
        grouped['Africa'].push(timezone);
      }
    });

    return grouped;
  }

  copyToClipboard(text: string): Promise<void> {
    return navigator.clipboard
      .writeText(text)
      .then(() => {})
      .catch(e => {});
  }

  initDeviceId(): string {
    const storedDeviceId = localStorage.getItem('deviceId');

    if (storedDeviceId) {
      this.deviceId = storedDeviceId;
      return this.deviceId;
    } else {
      this.deviceId = this.generateGuid();
      localStorage.setItem('deviceId', this.deviceId);
      return this.deviceId;
    }
  }

  generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
